
const StandardDropdown = ({ options, name, onChange, selectedValue, isDisabled, customStyles = {}}) => {
    return (
        <select style={customStyles} disabled={isDisabled} name={name} value={selectedValue} onChange={onChange}>
            {options.map((option) => (
                <option id={option.value} key={option.value} value={option.value}>
                    {option.text}
                </option>
            ))}
        </select>
    );
};

export default StandardDropdown;
